<template>
  <common-dialog ref="dialog" :title="title" width="350px" :close-on-click-modal="false" :in-dialog="inDialog">
    <div>
      <el-form ref="form" label-width="70px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="班级">
              <el-select v-model="data.ClassIds" multiple clearable  size="mini" style="width:100%;">
                <el-option v-for="item in classList" :key="item.ClassId" :value="item.ClassId" :label="item.ClassName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="text-align:right">
      <el-button type="primary" @click="confirm">确 定</el-button>
      <el-button @click="close">关 闭</el-button>
    </div>
  </common-dialog>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import listDialogMixins from "@/mixins/listDialog";

export default {
  components: { commonDialog },
  mixins: [listDialogMixins],
  props: {
    title: {
      type: String,
      default: "查询条件",
    },
  },
  data() {
    return {
      api: require("@/api/achieve/exam").default,
      classApi: require("@/api/ed/class").default,
      data: {
        ClassIds: [],
      },
      classList: [],
      gradeList: []
    }
  },
  methods: {
    setData(id,TermId) {
      this.api.list({ Id: id }).then(res => {
        if(res.Code == 0) {
          res.Data.forEach((e,index) => {
            if(this.gradeList.indexOf(e.GradeId) == -1) {
              this.gradeList.push(e.GradeId);
            }
            if(index == res.Data.length-1) {
              this.classList = [];
              this.gradeList.forEach(e => {
                this.classApi.list({ GradeId: e, TermId }).then(cres => {
                  if(cres.Code == 0) {
                    this.classList = this.classList.concat(cres.Data);
                  }
                })
              })
            }
          })
        }
      })
    },
    reset() {
      this.data = {
        ClassIds: []
      }
    },
    confirm() {
      // if(!this.data.ClassIds.length) {
      //   this.$message.error("请先选择班级");
      //   return
      // }
      this.$emit("confirm",this.data);
      // this.data = {
      //   ClassIds: []
      // }
      this.close();
    }
  },
};
</script>